import {
    BUSINESS_AGREEMENT_STATUS_DISMISSED,
    BUSINESS_AGREEMENT_STATUS_DRAFT,
    BUSINESS_AGREEMENT_STATUS_READY,
    DOSSIER_MANDATORY,
    DOSSIER_NOT_MANDATORY
} from "./Constants";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";


export const useStatusValuesBusinessAgreement = () => {
    const {t} = useTranslation(['salesmarketing']);
    const theme = useTheme();
    const getStatusColorAgreement = (status: string) => {
        switch (status) {
            case BUSINESS_AGREEMENT_STATUS_READY: return theme.palette.success.transparent;
            case BUSINESS_AGREEMENT_STATUS_DISMISSED: return theme.palette.error.transparent;
            case BUSINESS_AGREEMENT_STATUS_DRAFT: return theme.palette.warning.transparent;
        }
    };

    const getStatusLabelAgreement = (status: string) => {
        switch (status) {
            case BUSINESS_AGREEMENT_STATUS_READY: return t('salesmarketing:businessAgreement.statusValues.ready');
            case BUSINESS_AGREEMENT_STATUS_DISMISSED: return t('salesmarketing:businessAgreement.statusValues.dismissed');
            case BUSINESS_AGREEMENT_STATUS_DRAFT: return t('salesmarketing:businessAgreement.statusValues.draft');
            case DOSSIER_MANDATORY: return t('salesmarketing:businessAgreement.dossierMandatory');
            case DOSSIER_NOT_MANDATORY: return t('salesmarketing:businessAgreement.dossierNotMandatory');
        }
    };

    return {
        getStatusColorAgreement,
        getStatusLabelAgreement
    }
}